import { observable, action, runInAction } from "mobx";

export default class NavigationStore {
  @observable
  navigationTabs = [{}];

  @observable
  tabIndex = 0;

  @action
  setTabIndex = (index) => {
    this.tabIndex = index;
  };
  @action
  addTabIndex = () => {
    this.tabIndex = this.tabIndex + 1;
  };

  @action
  setNavigationTabs = (newTab) => {
    if (this.navigationTabs.some((e) => e.tid === newTab.tid)) {
      const objIndex = this.navigationTabs.findIndex(
        (obj) => obj.tid === newTab.tid
      );
      if (objIndex === -1) return;
      this.setTabIndex(objIndex);
    } else if (!this.navigationTabs.some((e) => e.tid === newTab.tid)) {
      // -2 because .push function return the length of the array and first item is empty
      this.setTabIndex(this.navigationTabs.push(newTab) - 2);
      if (this.navigationTabs.length > 4) {
        runInAction(() => {
          this.navigationTabs = this.navigationTabs.filter((item, index) => {
            return index !== 0 && item.tid !== undefined;
          });
        });
        this.setTabIndex(this.navigationTabs.length - 1);
      }
    }
  };
  @action
  resetNavigationTabs = () => {
    this.navigationTabs = [{}];
    this.setTabIndex(0);
  };
  @action
  setTabsInfos = (entityData) => {
    const objIndex = this.navigationTabs.findIndex(
      (obj) => obj.tid === entityData?.item?.object?.tid
    );
    if (objIndex && objIndex !== -1) {
      runInAction(() => {
        this.navigationTabs[objIndex].datas = entityData;
      });
    }
  };

  @action
  closeSpecificTab = (tid) => {
    if (tid)
      runInAction(() => {
        this.navigationTabs = this.navigationTabs.filter((e, index) => {
          if (e.tid === tid) {
            this.setTabIndex(index - 1);
            return false;
          } else return true;
        });
      });
  };
}
